import { createSvgIcon } from "@mui/material";

export const Icon = createSvgIcon(
  <>
    <path d="M20.64,4.36l-8.31-2.31c-.22-.06-.44-.06-.66,0L3.36,4.36c-.89.25-.96,1.54-.96,1.71,0,.3.02.72.06,1.24.09,1.04.32,2.48.84,4.11,1.05,3.27,3.29,7.31,8.02,10.39.42.27.94.27,1.36,0,4.73-3.08,6.97-7.11,8.02-10.39.52-1.63.75-3.07.84-4.11.05-.52.06-1.24.06-1.24-.01-.79-.04-1.45-.96-1.71ZM11.92,18.88c-.17,0-.26-.05-.41-.15-3.4-2.22-5.01-5.12-5.77-7.47-.37-1.17-.54-2.21-.6-2.95-.03-.37-.04-.68-.05-.89,0-.12.05-1.05.69-1.23l5.98-1.66c.05-.01.11-.01.16,0v14.35Z" />
  </>,
  "Insurance",
);

export default Icon;
